import React, { useEffect, useState } from "react";
import pdfIcon from "../../assets/images/pdfIcon.svg";
import rightArrow from "../../assets/images/rightArrow.svg";
import { Checkbox } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getShowAgreementAction,getShowAgreementHandler } from "../../redux/action/getShowAgreement";
import Loader from "../Loder/loader";
import { useCommonMessage } from "../../common/CommonMessage";
import NoAnyDocs from "../noAnyDocs/NoAnyDocs";
import { checkDocumentStatusAction, checkDocumentStatusHandler } from "../../redux/action/checkDocumentStatusSlice";

const Consent = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [showNoDocsError, setShowNoDocsError] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const navigate = useNavigate();
  const getShowAgreementSelector = useSelector(
    (state) => state?.getShowAgreementMain
  );
  const checkDocumentStatusSelector = useSelector((state) => state?.checkDocumentStatus);

  const handleCloseErrorModal = () => {
    setShowNoDocsError(false);
    navigate("/dashboard");
    dispatch(getShowAgreementAction.getShowAgreementInfoReset());
  };



const handleCheckDocumentStatus = (item) => {
  console.log(item,"item");
  let payload = {
    id: item?.id,
  };
  console.log(payload,"payload");
  setPdfData(item);
  dispatch(checkDocumentStatusHandler(payload));
};

const messageApi = useCommonMessage();
useEffect(() => {
  if(checkDocumentStatusSelector?.data?.data?.isActive===true){
    navigate("/preview-pdf", { state: pdfData });
    dispatch(checkDocumentStatusAction.checkDocumentStatusInfoReset());
  }else if (checkDocumentStatusSelector?.data?.data?.isActive===false && checkDocumentStatusSelector?.data?.data?.files?.length===0){
    setShowNoDocsError(true);
  }else if (checkDocumentStatusSelector?.data?.data?.isActive===false && checkDocumentStatusSelector?.data?.data?.files?.length>0){
    // navigate("/pdf-review", { state: pdfData });
    messageApi.open({
      type: "error",
      content: checkDocumentStatusSelector?.data?.message,
    });
    dispatch(checkDocumentStatusAction.checkDocumentStatusInfoReset());
  }
}, [checkDocumentStatusSelector]);

  useEffect(() => {
    if(getShowAgreementSelector?.data?.data?.files?.length===0){
      setShowNoDocsError(true);
    }
  }, [getShowAgreementSelector]);
  
  
  useEffect(() => {
    dispatch(getShowAgreementHandler());
  }, [checkDocumentStatusSelector]);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <>
      {(getShowAgreementSelector?.isLoading || checkDocumentStatusSelector?.isLoading) && (
        <Loader loaderTransForm="loaderTransForm" />
      )}
      <div className="">
        <div className="consentForm mx-auto">
          <div
            className=""
            dangerouslySetInnerHTML={{
              __html: getShowAgreementSelector?.data?.data?.agreementHtml,
            }}
          />
          <div className="divider"></div>
          <h2 className="fw-600 mb-20"> {t("Review and Sign Documents.")}</h2>

          <div className="d-flex gap-10 mb-40 flex-lg tempGrid">
            {getShowAgreementSelector?.data?.data?.files?.map((item, index) => {
              return (
                <div
                  className="pdfPreview justify-between cursor-pointer "
                  // onClick={() => navigate("/preview-pdf", { state: item })}
                  onClick={() => handleCheckDocumentStatus(item)}
                  key={index}
                >
                  <div className="d-flex align-center gap-6">
                    <img src={pdfIcon} alt="" />
                    <p className="m-0">
                    {item?.fileName?.length > 20 ? item?.fileName?.slice(0, 30) + "..." : item?.fileName}
                    </p>
                  </div>
                  <img src={rightArrow} alt="" />
                </div>
              );
            })}
          </div>
          <div className="d-flex mb-40">
            <Checkbox
              className="customCheckbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
            >
              {t("I agree to review and sign the documents.")}
            </Checkbox>
          </div>
          <div className="mx420">
            <button
              // className="primaryButton w-100 cursor-pointer disable  activeted"
              className={`primaryButton w-100 cursor-pointer ${
                isChecked ? "activeted" : "disable"
              }`}
              onClick={() => navigate("/eSign")}
              disabled={!isChecked}
            >
              {t("Sign Document")}
            </button>
          </div>
        </div>
      </div>
      {showNoDocsError && (
        <NoAnyDocs showNoDocsError={showNoDocsError} handleCloseErrorModal={handleCloseErrorModal} />
      )}
    </>
  );
};

export default Consent;
